module.exports = __webpack_public_path__ + "img/filter-icon.svg";